<template>
  <div>
    <!-- <dashboardNavbar /> -->
    <div class="main main_style">
      <div class="row dashboard-header-name">
        <!-- <p class="dashboard-heading source-sans-pro px-5 mt-4">{{$t('DASHBOARD_PAGE.DASHBOARD')}}</p> -->
      </div>
      <div style="text-align:right;">
      <div style="text-align:right;display:inline-block;" v-if="isDeleteAllowed"><button class="btn btn-primary btn-warnn" 
      style="margin:10px 20px -12px 0px;font-weight:bold;
      height: 30px;font-size: 13px;" @click="isDeleteAccountClickedFn()"
      v-if="isDeleteAllowed">
      Delete Account &#9432;</button></div>
      <div style="text-align:right;display:inline-block;" v-if="isTaxComponentAllowed"><button class="btn btn-primary" 
      style="margin:10px 20px -12px 0px;font-weight:bold;
      height: 30px;font-size: 13px;" @click="essential = true">Register Tax Components</button></div>
      </div>
      <div class="row mb-5 mx-3 mt-5" style="margin-top:20px!important">
        <div class="col-12 col-md-4 px-3" style="padding-bottom:10px;">
          <div class="card bussinesscard card-width w-100 h-100 m-auto p-0">
            <p class="source-sans-pro px-2 m-0 inner-card-headings py-2">Profile 
          <span style="font-weight: bold;float: right;font-size: 15px;">
            Partner Number: {{dashboardData.partnerNumber}}</span></p>
            <hr class="hr-style mb-3" />
            <div class="row m-0 p-0">
              <div class="col p-0">
                <p
                  class="source-sans-pro pl-3 w-100 text-left profile-completion-text font-weight-bold"
                >{{ $t("DASHBOARD_PAGE.PROFILE_COMPLETION") }}</p>
              </div>
              <div class="col p-0 pr-3">
                <p class="text-right font-weight-bold profile-completion-text source-sans-pro">
                  <span v-if="isNaN(profileCompletionPercentage)">0%</span>
                  <span v-else>{{ profileCompletionPercentage }}%</span>
                </p>
              </div>
            </div>
            <div class="row p-0 m-0 px-3 mt-0">
              <b-progress
                class="w-100 progress-color"
                :value="profileCompletionPercentage"
                :max="100"
              ></b-progress>
            </div>
            <div class="row p-0 m-0 px-3 source-sans-pro progress-text h-100">
              <p class="mt-3">{{ $t("GENERAL.PROFILE_COMPLETION_TEXT") }}</p> 
              <b-button v-if="!dontShowBussinessType" @click="copyPrimaryData()" class="gradient-button">Import Data from Primary Business</b-button>              
            </div>
            <div class="row m-0 p-0">
              <div class="col p-0 pl-3 mb-3 m-auto">
                <div
                  @click="goToOnboardingPage()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                  v-if="onBoardingCompletionStatus =='OnProgress'" style="float:left;padding-left: 0px !important;"
                >
                  COMPLETE PROFILE
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                  
                </div>
                <div style="float: right;padding-right: 18px;text-decoration:underline;
                cursor:pointer" @click="resetBusinessTypeConformation()" v-if="dontShowBussinessType">Reset business type</div>
                <p
                  @click="goToOnboardingPage()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                  v-if="onBoardingCompletionStatus =='View'"
                >
                  VIEW PROFILE
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                </p>
                <p v-if="onBoardingCompletionStatus =='Edit' " style="text-align: left;
                font-weight: bold;background: #fdff75; margin: 10px 20px 0px 10px; 
                padding: 10px 10px 0px 10px;color: #000;">
                    Your profile has been Sent Back for correction with Remarks:
                </p>
                <p v-if="onBoardingCompletionStatus =='Edit'" style="text-align: left;
                background: #fdff75; margin: 0px 20px 10px 10px; 
                padding: 0px 10px 10px 10px;">
                   {{recentStatusChangeRemarks}}
                </p>
                <p
                  @click="goToOnboardingPage()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                  v-if="onBoardingCompletionStatus =='Edit' "
                >
                  EDIT PROFILE
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                </p> 
              </div>
              <div class="col-12" style="padding:0px 10px 10px 10px;"
              v-if="isMigratedUser != 'N' && isAllowedEIPWithoutOnboarding && dashboardData.timeTillEIPMenuAllowed !== null">
              <div style="color: #dc0000;font-size: 11px;font-weight: bold;">EIP link will be enabled only till- {{timeTillEIPMenuAllowed}}.</div>
              <b-button @click="navigateToEIP(2)" class="eip-link"
         style="background: #055496;font-weight: bold;
         font-size:14px;padding: 4px 15px;height: 32px;line-height: 17px;width: 100%;"
         v-if="isShowEIPLink(2)"
         :class="showHalfLength(2)"
         >
          EIP 2.0 - Current EIP ></b-button>

         <b-button @click="navigateToEIP(4)" class="eip-link"
         style="background: #055496;font-weight: bold;margin-left: 2px;
         font-size:14px;padding: 4px 20px;height: 32px;line-height: 17px;width: 100%;"
         v-if="isShowEIPLink(4)"
         :class="showHalfLength(4)"
        >
          EIP 4.0 - New EIP ></b-button>


              </div>
              <div v-if="isMigratedUser != 'N' && !isAllowedEIPWithoutOnboarding && dashboardData.timeTillEIPMenuAllowed !== null"  class="col-12" style="padding: 0px 10px 10px;" >
                <div style="border: 1px solid #cca226;background: #ffce38;border-radius: 5px;
                padding: 5px;font-size: 13px;color: #000;"><span class="excl">!</span>EIP link is no longer available since you didn't complete the profile within due date! Complete the onboarding to access EIP.</div></div>
            </div>
          </div> 
        </div>
        <div v-if="!showBranch" class="col-12 col-md-4 px-3" style="padding-bottom:10px;">
          <div class="card bussinesscard card-shadows w-100 h-100">
            <p class="source-sans-pro px-2 pl-3 m-0 inner-card-headings py-2">Primary Business</p>
            <hr class="hr-style mb-3" />
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Business</p>
            <span v-if="dashboardData">
              <p
                class="source-sans-pro pl-3 px-2 w-100 text-left inner-details"
                v-if="dashboardData"
              >{{ (dashboardData && dashboardData.primaryBusiness) ? dashboardData.primaryBusiness.categoryName : '' }}</p>
            </span>
            <!-- <div class="m-0 px-3 h-75"> -->
            <!-- <div class="row m-0 p-0 text-left primary-card-text-style">
                <div class="col-lg-5 col-md-7 col-sm-11 p-0 font-weight-bold">Business</div>
                <div class="col-1 p-0 font-weight-bold">:</div>
                <div
                  class="col-lg-6 col-md-12 p-0"
                  v-if="dashboardData"
                >{{dashboardData.primaryBusiness.categoryName}}</div>
            </div>-->
            <span v-if="!dashboardData">-</span>
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Categories</p>
            <span v-if="dashboardData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span
                  v-for="(categories, index) in dashboardData.primaryBusiness
                    .categories"
                  :key="index"
                >
                  {{ categories.categoryName }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.categories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
            <span v-if="!dashboardData">-</span>
            <p
              class="source-sans-pro px-2 w-100 pl-3 text-left inner-sub-headings m-0"
            >Sub Categories</p>
            <span v-if="dashboardData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span
                  v-for="(subCategories, index) in dashboardData.primaryBusiness
                    .subCategories"
                  :key="index"
                >
                  {{ subCategories.categoryName }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.subCategories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>

            <!-- <span v-if="businessType">-</span> -->
            <p
              v-if="businessType"
              class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0"
            >Business type</p>
            <span v-if="businessType">
              <p class="source-sans-pro px-2 pl-3 w-100 text-left inner-details">
                <span
                  v-for="(businessTypes, index) in dashboardData.primaryBusiness
                    .businessTypes"
                  :key="index"
                >
                  {{ businessTypes.longDesc }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.businessTypes.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
            <div class="row m-0 p-0 h-100" v-if="!showBranch">
              <div
                class="col p-0 mb-3 m-auto"
                v-if="dashboardData.primaryBusiness.categoryCode == this.dashboardData.currentCategoryCode"
              >
                <p
                  @click="editPrimaryBusiness()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                >
                  <!-- {{$t('DASHBOARD_PAGE.COMPLETE_PROFILE')}} -->
                  + EDIT PRIMARY BUSINESS
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showBranch" class="col-12 col-md-4 px-3" style="padding-bottom:10px;">
          <div class="card bussinesscard card-shadows w-100 h-100">
            <p class="source-sans-pro px-2 m-0 inner-card-headings py-2">Secondary Business</p>
            <hr class="hr-style mb-3" />
            <span v-if="dashboardData && dashboardData.secondaryBusiness.length > 0">
              <!-- <p class="source-sans-pro progress-card-heading pl-3">Secondary Business A</p> -->
              <!-- <div class="row m-0 p-0 px-3 text-left primary-card-text-style">
                <div class="col-lg-5 col-md-7 col-sm-11 p-0 font-weight-bold">Business</div>
                <div class="col-1 p-0 font-weight-bold">:</div>
                <div
                  class="col-lg-6 col-md-12 p-0"
                  v-if="dashboardData"
                >{{dashboardData.secondaryBusiness[dashboardData.secondaryBusiness.length-1].categoryName}}</div>
              </div>-->
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Business</p>
              <span v-if="dashboardData">
                <p
                  class="source-sans-pro pl-3 px-2 w-100 text-left inner-details"
                  v-if="dashboardData"
                >
                  {{
                  dashboardData.secondaryBusiness[
                  dashboardData.secondaryBusiness.length - 1
                  ].categoryName
                  }}
                </p>
              </span>
              <span v-if="!dashboardData">-</span>
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Categories</p>
              <span v-if="dashboardData">
                <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                  <span
                    v-for="(category, index) in dashboardData.secondaryBusiness[
                      dashboardData.secondaryBusiness.length - 1
                    ].categories"
                    :key="index"
                  >
                    {{ category.categoryName }}
                    <span
                      v-if="
                        index !=
                          dashboardData.secondaryBusiness[
                            dashboardData.secondaryBusiness.length - 1
                          ].categories.length -
                            1
                      "
                    >,</span>
                  </span>
                </p>
              </span>
              <span v-if="!dashboardData">-</span>
              <p
                class="source-sans-pro px-2 w-100 pl-3 text-left inner-sub-headings m-0"
              >Sub Categories</p>
              <span v-if="dashboardData">
                <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                  <span
                    v-for="(subcategory, index) in dashboardData
                      .secondaryBusiness[
                      dashboardData.secondaryBusiness.length - 1
                    ].subCategories"
                    :key="index"
                  >
                    {{ subcategory.categoryName }}
                    <span
                      v-if="
                        index !=
                          dashboardData.secondaryBusiness[
                            dashboardData.secondaryBusiness.length - 1
                          ].subCategories.length -
                            1
                      "
                    >,</span>
                  </span>
                </p>
              </span>
              <span
                v-if="
                  dashboardData.secondaryBusiness[
                    dashboardData.secondaryBusiness.length - 1
                  ].businessTypes.length > 0
                "
              >
                <p
                  class="source-sans-pro px-2 w-100 pl-3 text-left inner-sub-headings m-0"
                >Business type</p>
                <span v-if="dashboardData">
                  <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                    <span
                      v-for="(subcategory, index) in dashboardData
                        .secondaryBusiness[
                        dashboardData.secondaryBusiness.length - 1
                      ].businessTypes"
                      :key="index"
                    >
                      {{ subcategory.longDesc }}
                      <span
                        v-if="
                          index !=
                            dashboardData.secondaryBusiness[
                              dashboardData.secondaryBusiness.length - 1
                            ].businessTypes.length -
                              1
                        "
                      >,</span>
                    </span>
                  </p>
                </span>
              </span>
            </span>
            <span
              v-if="
                dashboardData && dashboardData.secondaryBusiness.length == 0
              "
            >
              <p
                class="source-sans-pro progress-card-heading pl-3 m-auto h-100"
              >No Secondary Business chosen!</p>
            </span>
            <div class="row m-0 p-0 h-100">
              <div class="col p-0 mb-3 m-auto">
                <p
                  @click="addNewBusiness()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                >
                  <!-- {{$t('DASHBOARD_PAGE.COMPLETE_PROFILE')}} -->
                  + VIEW / ADD NEW BUSINESS
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showBranch" class="col-12 col-md-4 px-3" style="padding-bottom:10px;">
          <div class="card bussinesscard card-shadows w-100 h-100">
            <p
              class="source-sans-pro px-2 pl-3 m-0 inner-card-headings py-2"
            >Parent Primary Business</p>
            <hr class="hr-style mb-3" />
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Business</p>
            <span v-if="parentBussinessData">
              <p
                class="source-sans-pro pl-3 px-2 w-100 text-left inner-details"
                v-if="dashboardData"
              >{{ parentBussinessData.categoryName }}</p>
            </span>
            <!-- <div class="m-0 px-3 h-75"> -->
            <!-- <div class="row m-0 p-0 text-left primary-card-text-style">
                <div class="col-lg-5 col-md-7 col-sm-11 p-0 font-weight-bold">Business</div>
                <div class="col-1 p-0 font-weight-bold">:</div>
                <div
                  class="col-lg-6 col-md-12 p-0"
                  v-if="dashboardData"
                >{{dashboardData.primaryBusiness.categoryName}}</div>
            </div>-->
            <span v-if="!parentBussinessData">-</span>
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Categories</p>
            <span v-if="parentBussinessData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span v-for="(categories, index) in parentBussinessData.categories" :key="index">
                  {{ categories.categoryName }}
                  <span
                    v-if="
                      index <
                        parentBussinessData.categories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
            <span v-if="!parentBussinessData">-</span>
            <p
              class="source-sans-pro px-2 w-100 pl-3 text-left inner-sub-headings m-0"
            >Sub Categories</p>
            <span v-if="dashboardData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span
                  v-for="(subCategories, index) in parentBussinessData.subCategories"
                  :key="index"
                >
                  {{ subCategories.categoryName }}
                  <span
                    v-if="
                      index <
                        parentBussinessData.subCategories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>

            <!-- <span v-if="businessType">-</span> -->
            <p
              v-if="parentBussinessData"
              class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0"
            >Business type</p>
            <span v-if="parentBussinessData">
              <p class="source-sans-pro px-2 pl-3 w-100 text-left inner-details">
                <span
                  v-for="(businessTypes, index) in parentBussinessData
                    .businessTypes"
                  :key="index"
                >
                  {{ businessTypes.longDesc }}
                  <span
                    v-if="
                      index <
                        parentBussinessData.businessTypes.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
          </div>
        </div>
        <div v-if="showBranch" class="col-12 col-md-4 px-3" style="padding-bottom:10px;">
          <div class="card bussinesscard card-shadows w-100 h-100">
            <p class="source-sans-pro px-2 pl-3 m-0 inner-card-headings py-2">Branch Business</p>
            <hr class="hr-style mb-3" />
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Business</p>
            <span v-if="dashboardData">
              <p
                class="source-sans-pro pl-3 px-2 w-100 text-left inner-details"
                v-if="dashboardData"
              >{{ (dashboardData && dashboardData.primaryBusiness) ? dashboardData.primaryBusiness.categoryName : '' }}</p>
            </span>
            <!-- <div class="m-0 px-3 h-75"> -->
            <!-- <div class="row m-0 p-0 text-left primary-card-text-style">
                <div class="col-lg-5 col-md-7 col-sm-11 p-0 font-weight-bold">Business</div>
                <div class="col-1 p-0 font-weight-bold">:</div>
                <div
                  class="col-lg-6 col-md-12 p-0"
                  v-if="dashboardData"
                >{{dashboardData.primaryBusiness.categoryName}}</div>
            </div>-->
            <span v-if="!dashboardData">-</span>
            <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0">Categories</p>
            <span v-if="dashboardData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span
                  v-for="(categories, index) in dashboardData.primaryBusiness
                    .categories"
                  :key="index"
                >
                  {{ categories.categoryName }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.categories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
            <span v-if="!dashboardData">-</span>
            <p
              class="source-sans-pro px-2 w-100 pl-3 text-left inner-sub-headings m-0"
            >Sub Categories</p>
            <span v-if="dashboardData">
              <p class="source-sans-pro pl-3 px-2 w-100 text-left inner-details">
                <span
                  v-for="(subCategories, index) in dashboardData.primaryBusiness
                    .subCategories"
                  :key="index"
                >
                  {{ subCategories.categoryName }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.subCategories.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>

            <!-- <span v-if="businessType">-</span> -->
            <p
              v-if="businessType"
              class="source-sans-pro pl-3 px-2 w-100 text-left inner-sub-headings m-0"
            >Business type</p>
            <span v-if="businessType">
              <p class="source-sans-pro px-2 pl-3 w-100 text-left inner-details">
                <span
                  v-for="(businessTypes, index) in dashboardData.primaryBusiness
                    .businessTypes"
                  :key="index"
                >
                  {{ businessTypes.longDesc }}
                  <span
                    v-if="
                      index <
                        dashboardData.primaryBusiness.businessTypes.length - 1
                    "
                  >,</span>
                </span>
              </p>
            </span>
            <div class="row m-0 p-0 h-100">
              <div class="col p-0 mb-3 m-auto">
                <p
                  @click="addBranchBussinessDetail()"
                  class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3"
                >
                  <!-- {{$t('DASHBOARD_PAGE.COMPLETE_PROFILE')}} -->
                  + EDIT BRANCH BUSINESS
                  <img
                    class="right-arrow-complete-profile"
                    src="@/assets/images/right-arrow.svg"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- --------------------------------------------------BUSSINESS TYPE----------------------------------------------------->

      <div
        class="row mx-3 p-0 mt-5 mb-5"
        v-if="!dontShowBussinessType && onBoardingCompletionStatus != 'View'"
      >
        <div class="col-6 px-3">
          <div class="card bussinesscard card-shadows w-100 h-100">
            <div class="row">
              <div class="col">
                <p class="source-sans-pro progress-card-heading pl-3">Select Business Type</p>
              </div>
              <div class="col">
                <div class="row m-0 p-0 mx-3 px-3 w-100 h-100" v-if="businessType">
                  <div class="col p-0 mb-3 m-auto edit-business-type-col">
                    <p
                      @click="businessTypeChange()"
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-right right-align-edit-business"
                    >
                      EDIT BUSINESS TYPE
                      <img
                        class="right-arrow-complete-profile"
                        src="@/assets/images/edit-icon.svg"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span v-if="showBussinessTypes">
                <hr class="hr-style" />
                <!-- <p class="view-add-btn mx-3">Services</p>-->
                <b-form-group
                  label=" "
                  v-if="dashboardData && dashboardData.currentCategoryCode == 2"
                >
                  <div class="row p-0 m-0 ml-4">
                    <b-form-radio
                      class="mr-4"
                      v-for="service in serviceOptions"
                      :key="service"
                      name="businessTypes"
                      :value="service.value"
                      v-model="selectedRadio"
                      @change="pushToSelectedService(service.value)"
                    >{{ service.text }}</b-form-radio>
                  </div>
                </b-form-group>

                <b-form-checkbox-group
                  v-else
                  class="m-0 float-left px-3 checkbox-style py-4"
                  id="checkbox-group-1"
                  v-model="serviceSelected"
                  :options="serviceOptions"
                ></b-form-checkbox-group>
                <hr class="hr-style mb-1" />
                <div class="row pl-3">
                  <div class="col-auto">
                    <button
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left pb-2"
                      :disabled="!serviceSelected.length > 0"
                      @click="sendBusinessType()"
                    >Submit</button>
                  </div>
                  <div v-if="businessType" class="col-auto">
                    <button
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3 pb-2"
                      :disabled="!serviceSelected.length > 0"
                      @click="cancelEditedBusiness()"
                    >Cancel</button>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
          <div class="col-6 px-3" v-if="showSelectCurrencyType && onBoardingCompletionStatus !='View'">
          <div class="card bussinesscard card-shadows w-100" style="height:initial !important;">
            <div class="row">
              <div class="col">
                <p class="source-sans-pro progress-card-heading pl-3">Select Currency Type</p>
              </div>
              <div class="col">
                <div class="row m-0 p-0 mx-3 px-3 w-100 h-100" v-if="currencyType">
                  <div class="col p-0 mb-3 m-auto edit-business-type-col">
                    <p
                      @click="currencyTypeChange()"
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-right right-align-edit-business"
                    >
                      EDIT CURRENCY TYPE
                      <img
                        class="right-arrow-complete-profile"
                        src="@/assets/images/edit-icon.svg"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span v-if="showCurrencyTypes">
                <hr class="hr-style" />
                <b-form-group label=" " v-if="dashboardData">
                  <div class="row">
                    <div class="col-6">
                      <b-form-group
                        class="source-sans-pro bold text-left ml-3"
                        label="Operating Currency"
                      >
                        <w-dropdown
                          class="width-control-small"
                          :options="currencyOptions"
                          @dropdownChange="getPartnerCurrencyType($event)"
                          :selected="selectedCurrency"
                          :disabled="!this.$root.isInternational"
                        /><!--
                          :disabled="selectedCurrency"-->
                      </b-form-group>
                    </div>
                    <div class="col-6">
                      <b-form-group
                        class="source-sans-pro bold text-left mr-3"
                        label="Currency Unit"
                      >
                        <w-dropdown
                          class="width-control-small"
                          :options="currencyUnitsOptions"
                          @dropdownChange="getPartnerCurrencyUnitType($event)"
                          :selected="selectedCurrencyUnit"
                          :disabled="!selectedCurrency"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </b-form-group>
                <div class="row pl-3">
                  <div class="col-auto">
                    <button
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left pb-2"
                      :disabled="!selectedCurrency || !selectedCurrencyUnit"
                      @click="sendCurrencyType()"
                    >Submit</button>
                  </div>
                  <div v-if="currencyType" class="col-auto">
                    <button
                      class="source-sans-pro m-0 p-0 complete-profile-btn cursor-pointer text-left px-3 pb-2"
                      @click="cancelEditCurrencyType()"
                    >Cancel</button>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div> 
      </div>

      <!-- -----------------------------------------------------------------------------------------------E-BID start----------------------------------------------------->

      <!-- <div class="row mb-5 mx-3">
        <div class="col-6 Auction">
          <p class="card-top-headings text-left">E-Bid</p>
          <div class="Ebid-card">
            <w-ebid-table :tableLoading="showTableLoding" :tableValue="ebidDataTable" />
          </div>
        </div>
        <div class="col-6 Auction">
          <p class="card-top-headings text-left">E-Auction</p>
          <div class="Ebid-card">
            <w-ebid-table :tableLoading="showTableLoding" :tableValue="ebidDataTable" />
          </div>
        </div>
      </div>-->
      <div class="col-12 px-4 mb-3">
        <div class="card bussinesscard card-shadows w-100 h-100">
          <p class="source-sans-pro px-2 p-0 m-0 inner-card-headings py-2">E-Bid & E-Auction</p>
          <date-picker
            v-model="selectedDateRange"
            range
            :lang="'en'"
            confirm
            @confirm="getEbidAuctionDate($event)"
            :format="'D-MMM-YYYY'"
            :shortcuts="false"
            :not-after="disableDateAfter"
            :not-before="disableDateBefore"
            class="drop-down p-0 m-0 mt-n5 pt-3 pb-2 pr-1 ml-auto"
          ></date-picker>
          <hr class="hr-style mb-1" />
          <div class="row mb-5 mx-2">
            <div class="col-12 col-md-6 Auction">
              <p class="bid-top-headings p-0 m-0 mb-1 text-left">E-Bid</p>
              <div class="Ebid-card">
                <w-ebid-table
                  :tableLoading="showTableLoding"
                  :tableValue="ebidDataTable"
                  :bidType="'Bid'"
                  @viewDetails="redirectionPage($event)"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 Auction">
              <p class="bid-top-headings p-0 m-0 mb-1 text-left">E-Auction</p>
              <div class="Ebid-card">
                <w-ebid-table
                  :tableLoading="showTableLoding"
                  :tableValue="eAuctionTable"
                  :bidType="'Auction'"
                  @viewDetails="redirectionPage($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  <div class="row mb-5 mx-3">
        <div class="col Auction">
          <b-card header-tag="header" footer-tag="footer">
            <template class="performance-card" v-slot:header>
              <span class="p-0 m-0 pt-1 float-left text-heading">E-Bid</span>
              <date-picker
                v-model="selectedDateRange"
                range
                :lang="'en'"
                confirm
                @confirm="getEbidAuctionDate($event)"
                :format="'D-MMM-YYYY'"
                :shortcuts="false"
                :not-after="disableDateAfter"
                :not-before="disableDateBefore"
                class="drop-down col-4 p-0 m-0 float-right"
              ></date-picker>
            </template>
            <div>
              <w-ebid-table
                :tableLoading="showTableLoding"
                :tableValue="ebidDataTable"
                :bidType="'Bid'"
                @viewDetails="redirectionPage($event)"
              />
            </div>
          </b-card>
        </div>
        <div class="col Auction">
          <b-card header-tag="header" class="performance-card" footer-tag="footer">
            <template v-slot:header>
              <span class="p-0 m-0 pt-1 float-left text-heading">E-Auction</span>
              <date-picker
                v-model="selectedDateRange"
                range
                :lang="'en'"
                confirm
                @confirm="getEbidAuctionDate($event,i)"
                :format="'D-MMM-YYYY'"
                :shortcuts="false"
                :not-after="disableDateAfter"
                :not-before="disableDateBefore"
                class="drop-down col-4 p-0 m-0 float-right"
              ></date-picker>
            </template>
            <div>
              <w-ebid-table
                :tableLoading="showTableLoding"
                :tableValue="eAuctionTable"
                :bidType="'Auction'"
                @viewDetails="redirectionPage($event)"
              />
            </div>
          </b-card>
        </div>
      </div>  !-->

      <!-- --------------------------------------------------------------------------------------------------Empty Card End----------------------------------------------------->

      <span v-if="businessType">
        <div class="row">
          <p
            class="source-sans-pro font-weight-bold text-left pl-5 card-top-headings"
          >Overall Progress</p>
        </div>
        <div class="row m-0 p-0 mt-2 mx-3 mb-2">
          <div class="col-12">
            <div class="card bussinesscard card-sizing card-shadows px-5 py-5 full-height">
              <p
                class="source-sans-pro font-weight-bold text-left pl-0 card-top-headings mb-0"
              >All Modules</p>
              <div class="row mt-auto mb-auto">
                <!-- <div class="col-8"> -->
                <!-- <w-radar-charts
                  v-if="listOfModules.length>0 && percentageOfModules.length>0"
                  :type="'radar'"
                  :labelName="'Progress'"
                  :labels="listOfModules"
                  :data="percentageOfModules"
                  :colors="lineColors"
                  :borderColor="'#1549ab'"
                  class="pt-3"
                />-->
                <w-charts
                  v-if="
                    listOfModules.length > 0 && percentageOfModules.length > 0
                  "
                  :type="'pie'"
                  :labelName="'Progress_PieChart'"
                  :labels="['Completed', 'Yet to be Completed']"
                  :data="doughnutChartData"
                  :colors="lineColors"
                  :borderColor="'#1549ab'"
                  class="pt-3"
                  :showLegend="true"
                  :showModuleLegends="true"
                  :scaleDataForPolarChart="{}"
                  @getModuleCharts="getGroupCharts($event)"
                />
                <!-- </div> -->
                <!-- <div class="col">
                <w-dropdown />
                </div>-->
                <!-- <div class="col fixed-height">
                <div class="row mt-2 mx-3" v-if="moduleData">
                  <div class="col-12 px-3 mb-5" v-for="modules in moduleData" :key="modules">
                    <w-setupCard
                      :cardHeading="modules.moduleName"
                      :cardContent="modules.description"
                      :profileCompletionPercentage="parseInt((modules.answeredQuestions/modules.totalQuestions)*100)"
                      :btnText="'SETUP'"
                      :linkTo="modules.moduleCode"
                      @goToModule="goToOnboardingPageModule($event)"
                    />
                  </div>
                </div>
                </div>-->
              </div>
            </div>
          </div>
          <div
            class="col-6"
            v-if="
              listOfModules.length > 0 &&
                percentageOfModules.length > 0 &&
                groupChartData.length > 0
            "
          >
            <div
              class="card bussinesscard card-sizing card-shadows px-5 py-5 full-height"
              v-if="selectedModule"
            >
              <p
                class="source-sans-pro font-weight-bold text-left pl-0 card-top-headings mb-0"
              >{{ selectedModule }} Details</p>
              <p class="text-left source-sans-pro mb-0 module-description">{{ groupContent }}</p>
              <w-polar-charts
                :type="'polarArea'"
                :labelName="'Progress_Barchart'"
                :data="groupChartData"
                :xAxesData="{}"
                :colors="lineColors"
                :borderColor="'#1549ab'"
                :showLegend="false"
                class="mt-4"
                :scaleDataForPolarChart="{
                  ticks: {
                    min: 0,
                    max: 100,
                    stepSize: 20
                  }
                }"
                :showModuleLegends="true"
              />
            </div>
          </div>
        </div>
        <!-- xAxes: [
                  {
                    display: true,
                    ticks: {
                      beginAtZero: true,
                      steps: 10,
                      stepValue: 5,
                      max: 100
                  }
                 }
        ]-->
        <!-- <div class="row m-0 p-0 mt-2 mx-3 mb-2" v-if="!moduleData">
          <div class="card w-100 mx-3">
            <div class="row m-0 p-0 row-loader m-auto my-4">
              <b-spinner class="mt-auto mb-auto" :variant="'primary'" type="grow"></b-spinner>
              <b-spinner class="mt-auto mb-auto" :variant="'primary'" type="grow"></b-spinner>
              <b-spinner class="mt-auto mb-auto" :variant="'primary'" type="grow"></b-spinner>
            </div>
          </div>
        </div>-->
        <!-- <div class="row mt-2 mx-3" v-if="moduleData">
          <div class="col-4 px-3 mb-5" v-for="modules in moduleData" :key="modules">
            <w-setupCard
              :cardHeading="modules.moduleName"
              :cardContent="modules.description"
              :profileCompletionPercentage="parseInt((modules.answeredQuestions/modules.totalQuestions)*100)"
              :btnText="'SETUP'"
              :linkTo="modules.moduleCode"
              @goToModule="goToOnboardingPageModule($event)"
            />
          </div>
        </div>-->
      </span>
    </div>
    <b-modal
      v-if="isDeleteAccountClicked"
      v-model="isDeleteAccountClicked"
      centered
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      id="secondary-business"
      size="lg"
    >
    <div>
      <div style="background:orange;padding:10px;color:#fff;">Warning: Account will be deleted permanently</div>
      <div style="padding:10px;text-align:center;font-size:16px;">Your Account will be deleted completely and cannot be reversed and you will be logged out. 
      <span style="text-decoration:underline;font-weight:bold;">
        However you can do the registration again with same details.</span><br><br> 
        Click below button to Confirm Delete account and logout.
        </div>
        <div style="text-align:center;margin-bottom:20px;">
          <button class="btn btn-secondary" style="margin-right:20px;"
          @click="isDeleteAccountClicked=false">Cancel</button>
          <button class="btn btn-warning" style="background:#ff3900;color:#fff;"
          @click="deleteAccountConfirm()">Delete Account and Logout</button>
          </div></div>
    </b-modal>
    <b-modal
      v-if="essential"
      v-model="essential"
      centered
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      id="essential"
      size="lg"
    >
    <div>
<storecomp :countrycode="countrycode" :companycode="dashboardData.currentCompanyCode"
:categorycode="dashboardData.currentCategoryCode"
:partnerid="partnerId"></storecomp>
    </div>
    </b-modal>
    <b-modal
      v-if="addBusinessModal"
      v-model="addBusinessModal"
      centered
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      id="secondary-business"
      size="lg"
    >
      <p class="secondary-account-modal m-2">
        <span v-if="addPrimaryBussiness">PRIMARY ACCOUNT</span>
        <span v-if="addSecondaryBussiness">SECONDARY ACCOUNT</span>
        <span v-if="addBranchBussiness">BRANCH ACCOUNT({{parentBussinessData.categoryName}})</span>
        <img
          @click="closeSecondaryModal()"
          class="pb-1 secondary-close cursor-pointer"
          src="@/assets/images/close1.svg"
        />
      </p>
      <hr class="hr-style mb-3" />
      <w-editableTable
        v-if="!addBranchBussiness"
        :items="addPrimaryBussiness == true ? primaryBusinessesPopupItems: secondaryBusinessesPopupItems"
        :fields="addPrimaryBussiness == true ?primaryBusinessFields:secondaryBusinessFields"
        :bussinessType="addPrimaryBussiness == true ? 'primary': 'secondary'"
        @addSecondaryBussinessEvent="updateTheSecondaryBussiness($event)"
        @showFailureModal="showAlertBusinessModal($event)"
        @closeModal="closeSecondaryModal()"
        :partnerId="partnerId"
        :ref="'secondaryBusinessModal'"
      />
      <div class="px-3" v-if="addBranchBussiness">
        <div
          class="row mb-2 mx-2"
          style="font-size:15px;font-weight: bold;color: #636567;"
        >Select Your Business Category</div>
        <div class="row px-2">
          <div class="col-6">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              :labelText="'Category'"
              :position="'bottom'"
              :labelClass="'label-class'"
              :optionFields="branchBussinessAllCategory"
              @selectedMultiselectEvent="getMultiCategorySelectedDropdown($event)"
              :defaultValue="dashboardData.primaryBusiness.categories.length == 0 ? bindCategoryValue(branchBussinessAllCategory,'onetime'): bindCategoryValue(multiCategorySelectedValues,'edit')"
            />
          </div>
          <div class="col-6" v-if="addBranchBussiness">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              :labelText="'Sub-Category'"
              :position="'bottom'"
              :labelClass="'label-class'"
              :optionFields="branchBussinessSubCategory"
              @selectedMultiselectEvent="getMultiSubCategorySelectedDropdown($event)"
              :defaultValue="dashboardData.primaryBusiness.subCategories.length == 0 ? bindSubCategoryValue(branchBussinessSubCategory,'onetime'): bindSubCategoryValue(multiSubCategorySelectedValues,'edit')"
            />
          </div>
        </div>
        <b-button
          class="float-right mr-2 mb-3 cursor-pointer"
          @click="dashboardData.primaryBusiness.subCategories == null ? branchBussinessCategorySelect('onetime'): branchBussinessCategorySelect('edit')"
          v-if="addBranchBussiness"
          :disabled="multiCategorySelectedValues.length == 0 || multiSubCategorySelectedValues.length == 0"
        >
          <span v-if="dashboardData.primaryBusiness.subCategories.length == 0">Continue</span>
          <span v-else>Update</span>
        </b-button>
      </div>
      <!-- <v-stepper v-model="branchInfo" vertical v-if="addBranchBussiness">
        <v-stepper-step step="1">Select Your Bussiness Category</v-stepper-step>
        <v-stepper-content step="1">
          <div class="row ml-2">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              :labelText="'Category'"
              :position="'bottom'"
              :labelClass="'label-class'"
              :optionFields="branchBussinessCategory"
              @selectedMultiselectEvent="getMultiCategorySelectedDropdown($event)"
            />
          </div>
          <div class="row ml-2">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              :labelText="'Sub-Category'"
              :position="'bottom'"
              :labelClass="'label-class'"
              :optionFields="branchBussinessSubCategory"
              @selectedMultiselectEvent="getMultiSubCategorySelectedDropdown($event)"
            />
          </div>
          <v-btn @click="branchBussinessCategorySelect()" complete>Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step step="2">Select Your Bussiness Type</v-stepper-step>

        <v-stepper-content step="2">
          <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
          <v-btn color="primary" @click="branchBussinessTypeSubmit()">Submit</v-btn>
        </v-stepper-content>
      </v-stepper>-->

      <!--  <w-editableTable
        v-if="addBranchBussiness"
        :items="branchBusinessesPopupItems"
        :fields="BranchBussinessFileds"
        :bussinessType="'branch'"
        @addSecondaryBussinessEvent="updateTheBranchBussiness($event)"
        @showFailureModal="showAlertBusinessModal($event)"
        @closeModal="closeSecondaryModal()"
        :partnerId="partnerId"
        :ref="'secondaryBusinessModal'"
      />-->
    </b-modal>
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :isBoldText="boldText"  
      :needResendEmail="needResendEmail"
      :modalSize="modalSize"
      :sscNotification="sscNotification"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModel"
      :showSuccess="successModel"
      @eventClose="handleModel()"
    />
     <ssc-declaration-modal
      :trigger="triggerDeclarationModal"
      :title="'Declaration'" 
      :modalSize="'xl'"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :itrcutoffmonth="itrcutoffmonth"
      :idCardValue="idCardValue"
      :dashboardData="dashboardData"
      :showSkipDeclaration="showSkipDeclaration"
      @eventDeclarationClose="handleDeclarationModel()"
    />
    <w-overAll-confirmation
      :centered="true"
      @eventOk="resetBusinessType()"
      @eventCancel="closeConfirmationModal()"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :text="'The onboarding details you have already entered might be lost. Do you really want to change the business type?'"
      :trigger="resetBusinessTypeSubmitConformation"
    />
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import RadarChart from "../widgets/RadarChart.vue";
import Charts from "../widgets/Charts.vue";
import storecomp from "../widgets/storeComponent.vue";
import PolarCharts from "../widgets/PolarCharts.vue";
import SetupCard from "../widgets/SetupCard.vue";
import EditableTable from "../widgets/TableEditable";
import DropDown from "../widgets/DropDown";
import countDown from "../widgets/countdowntimer.vue";
import moment from "moment";
import Modal from "../widgets/ModalWidget";
import LoadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import sscdeclarationmodal from "../widgets/SSCDeclarationModal";
import dashboardNavbar from "../components/DashboardNavbar.vue";
import ebidTable from "../widgets/ebidtable";
import { DashboardService } from "../services/DashboardService.js";
const DashboardServices = new DashboardService();
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();
import DatePicker from "vue2-datepicker";
import multiSelectVue from "../widgets/multiSelect.vue";
import confirmationModal from "../widgets/confirmationModal";

import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

import { AESService } from "../services/AES.js";
let aesService = new AESService()
export default {
  created() {    
    this.loading = true;
    var self = this
  
    RegisterService.getWhistleBP().then(resp => {  
      if(resp.failureMessage == '') {
      } else{
          window.alert("Whistle Blower Policy not accepted. Kindly Re-login.")
          self.logOut()
      } 
    }).catch(err => {window.alert('Error getting Whistle Blower Policy Status. Try again later');self.logOut()})
    
    RegisterService.getUTDecl().then(resp => {  
      if(resp.failureMessage == '') {
      } else{
          window.alert("Undertaking Declaration not accepted. Kindly Re-login.")
          self.logOut()
      } 
    }).catch(err => {window.alert('Error getting Declaration Status. Try again later');self.logOut()})    

    DashboardServices.getSSCNotification('13').then(resp => {
        this.sscNotificationText= resp.response
    });
    DashboardServices.getPartnerCompanies()
        .then(resp => {
          if (resp.failureMessage == "") {
            self.companyList = resp.response.companyMappingResponseList
            self.navigationList = resp.response.companyNavigationResponseList
            self.defaultCompanyDetails = resp.response.companyMappingResponseList.filter(x=>x.isDefault==true)[0]

    if (
      this.$route.params &&
      this.$route.params.onboardStatus == "OnProgress"
    ) {
      this.dontshowEditPrimary = true;
      var currrentCompanyCode = this.$route.params.currentCompanyCode;
      var currentCategoryCode = this.$route.params.currentCategoryCode;
      this.currentPartnerName = this.$route.params.currentCategoryName;
      DashboardServices.getProfileDetails(
        currentCategoryCode,
        currrentCompanyCode
      ).then(resp => {
        if (resp.response == "User Category Audit Recorded") {
          // if (this.$router.currentRoute.name != "DashboardPage") {
          //   this.$router.push("/dashboard");
          // } else {
          //   this.$router.go(this.$router.currentRoute);
          // }
          this.getPartnerDetails();
          this.encrypt();
          // this.defaultSelection();
        }
      });
    } else {
      this.getPartnerDetails();
      this.encrypt();
      // this.defaultSelection();
    }
         } else{
           window.alert(resp.failureMessage)
         } })
        .catch(error => {
          this.loading = false;
           window.alert('Error getting company list. Please contact support.')
        });
  },
  components: {
    "ssc-declaration-modal":sscdeclarationmodal,
    "w-dropdown": DropDown,
    "w-radar-charts": RadarChart,
    "w-charts": Charts,
    "w-setupCard": SetupCard,
    "w-editableTable": EditableTable,
    "w-modal": Modal,
    "w-loading-spinner": LoadingSpinner,
    "w-polar-charts": PolarCharts,
    "w-countdown": countDown,
    "w-ebid-table": ebidTable,
    "w-multi-select-dropdown": multiSelectVue,
    "w-overAll-confirmation": confirmationModal,
    widgetModal,
    dashboardNavbar,
    DatePicker,
    storecomp
  },
    
  mounted(){    
    // this.getServicesList();
    // this.createChart('construction-chart', this.constructionChartData);
    // this.createChart('construction-line-chart', this.constructionLineChartData);
    var self = this
    this.$root.$on('closeessential', function(){
      self.essential = false;
    })
  },  
  watch: {
    /*serviceSelected: function(newVal,oldVal) {
      var proText = ''
      var self = this
       proText = this.serviceOptions.filter(x=>x.value==7)[0].text   
      if(newVal.indexOf(7) > -1) {
        self.serviceSelected = newVal.filter(x=>x==7)
        $('.custom-checkbox').each(function(x){
          if($('.custom-checkbox')[x].textContent != proText){
             $($('.custom-checkbox')[x]).addClass('disabled-check')
            console.log($('.custom-checkbox')[x])
          } else {            
             $($('.custom-checkbox')[x]).removeClass('disabled-check')
          }
        })
      } 
      if (newVal.indexOf(7) == -1) {
        self.serviceSelected = newVal.filter(x=>x!=7)
        $('.custom-checkbox').each(function(x){
          if($('.custom-checkbox')[x].textContent == proText){
             $($('.custom-checkbox')[x]).addClass('disabled-check')
            console.log($('.custom-checkbox')[x])
          } else {            
             $($('.custom-checkbox')[x]).removeClass('disabled-check')
          }
        })
      } 

      
      if (newVal.length == 0) {
        $('.custom-checkbox').each(function(x){
             $($('.custom-checkbox')[x]).removeClass('disabled-check')
        })
      }
    }*/
  },
  data() {
    return {
      copyDataArray: [],
      countrycode:100,
      essential: false,
      isDeleteAllowed:false,
      isTaxComponentAllowed:false,
      isDeleteAccountClicked:false,
      ebidintr: 1,
      itrcutoffmonth: 6,
      idCardValue:'',
      showSkipDeclaration: true,
      triggerDeclarationModal: false,
      sscNotificationText:'',
      showSscNotification: false,
      defaultCompanyDetails:'',
      navigationList:[],
      companyList:[],
      isMigratedUser: 'N',
      showEIP4LinkForLTC: 'false',
      showEIP4LinkForNonLTC: 'false',
      showEIP2LinkForLTC: 'false',
      showEIP2LinkForNonLTC: 'false',
      isAllowedEIPWithoutOnboarding: false,
      timeTillEIPMenuAllowed: '',
      eiplinkExtraGraceDate:'',
      resetBusinessTypeSubmitConformation: false,
      multiCategorySelectedValues: [],
      multiSubCategorySelectedValues: [],
      // primaryBussinessSelected: {
      //   categoryName:"",
      //   categoryCode:""
      // },
      branchInfo: 1,
      ebidData: [],
      currentPartnerName: "",
      saveSecondaryBussinessEvent: false,
      partnerId: "",
      companyCode : 0,
      profileCompletionPercentage: 0,
      lastResponse: "",
      successModel: false,
      alertModel: false,
      triggerModal: false,
      boldText: false,
      needResendEmail: false,
      modalSize: undefined,
      sscNotification: false,
      dontShowBussinessType: false,
      showBussinessModel: false,
      showTableLoding: false,
      showBussinessTypes: Boolean,
      loading: false,
      addBranchBussiness: false,
      chartLabelName: "Bids",
      chartLabel: ["Open Bids", "Closed Bids", "Pending Bids"],
      chartData: [44, 66, 20],
      chartColors: ["#0179b9", "#002d72", "#003da2"],
      lineLabelName: "Auction Price",
      lineLabels: ["LTC", "LNT", "LTI", "Larsen and Toubro", "LnT Const."],
      lineData: [200, 175, 169, 167, 168],
      lineColors: ["#0149a9", "#0149a9", "#1549ab", "#1549ab", "#1549ab"],
      serviceOptions: [],
      serviceSelected: [],
      dashboardData: {
        companyCode: 1,
        primaryBusiness:{},
        secondaryBusiness:[]
      },
      addBusinessModal: false,
      addPrimaryBussiness: false,
      addSecondaryBussiness: false,
      selectedRadio: "",
      moduleData: null,
      businessType: false,
      tableLoading: false,
      showBranch: false,
      primaryBusinessTypes: [],
      selectedBusinessTypes: [],
      parentBussinessData: [],
      primaryBusinessFields: [
        "Categories",
        "Sub-Categories",
        "Primary Bussiness"
      ],
      BranchBussinessFileds: ["Bussiness-Type", "Sub-Categories"],
      secondaryBusinessFields: ["Business", "Categories", "Sub-Categories"],
      fields: ["BidNumber", "Description", "Status", "Ends in", ""],
      items: [
        {
          isActive: true,
          BidNumber: "40",
          Description: "Dickerson",
          Status: "Live"
        },
        {
          isActive: true,
          BidNumber: "40",
          Description: "Dickerson",
          Status: "Live"
        },
        {
          isActive: true,
          BidNumber: "40",
          Description: "Dickerson",
          Status: "Live"
        },
        {
          isActive: true,
          BidNumber: "40",
          Description: "Dickerson",
          Status: "Live"
        }
      ],
      secondaryBusinessesPopupItems: [],
      primaryBusinessesPopupItems: [],
      branchBusinessesPopupItems: [],
      listOfModules: [],
      percentageOfModules: [],
      doughnutChartData: [],
      selectedModule: null,
      partnerCodeValue: [],
      // listOfGroups: ['Financial', 'Strength', 'Performance'],
      groupChartData: [],
      selectedDateRange: [],
      branchBussinessCategory: [],
      branchBussinessAllCategory: [],
      branchcategory: "",
      dontAllowOnboarding: false,
      branchBussinessSubCategory: [],
      disableDateBefore: "",
      disableDateAfter: "",
      groupContent: "",
      editedNow: false,
      onBoardingCompletionStatus: "",
      recentStatusChangeRemarks: "",
      onBoardingCompletion: "",
      editProfile: "",
      message: "Test",
      completeProfile: "",
      encryptsecret: atob(process.env.VUE_APP_E_S),
      options: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected
            ? {
                "background-color": "#ffffff"
              }
            : ""
      },
      ebidDataTable: {
        fields: [
          {
            key: "documentNo",
            label: "Bid Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "scope",
            label: "Description",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "startDate",
            label: "Status",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "endDate",
            label: "",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      eAuctionTable: {
        fields: [
          {
            key: "documentNo",
            label: "Bid Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "scope",
            label: "Description",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "startDate",
            label: "Status",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "endDate",
            label: "",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      currencyOptions: [],
      currencyUnitsOptions: [],
      selectedCurrency: "",
      selectedCurrencyUnit: "",
      currencyType: false,
      showCurrencyTypes: false,
      showSelectCurrencyType: true,
    };
  },
 
  methods: {   
    deleteAccountConfirm(){
      var self=this
          DashboardServices.deleteAccountConfirm(this.partnerId,this.dashboardData.currentCategoryCode)
            .then(resp => {
              if (resp.status=='SUCCESS') {
                this.loading = false;
                this.isDeleteAccountClicked = false;
                self.logOut()
              } else {
                this.loading = false;
                this.isDeleteAccountClicked = false;
                window.alert("Not able to  delete profile. plz contact support.")
              }
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.triggerModal = true;
              this.alertModel = true;
              this.lastResponse = err.failureMessage;
            });
    },
    isDeleteAccountClickedFn() {
      this.isDeleteAccountClicked = true
    }, 
    logOut() {
      var auditNumber = sessionStorage.getItem("AuditNumber");
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(auditNumber);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      // sessionStorage.clear();
      partnerService
        .userLogout(data)
        .then(res => {
          sessionStorage.clear();
          this.$router.push("/home");
        })
        .catch(err => {
          this.$router.push("/home");
          console.log(err);
        });
    },  
    showSSCNotification(){   
        this.sscNotification = false;
      var sscNotification = sessionStorage.getItem("sscNotificationshown");
      if(!sscNotification) {
        this.triggerModal = true;
        this.alertModel = true;
        this.boldText = false;
        this.sscNotification = true;
        this.modalSize = 'xl';
        this.lastResponse = this.sscNotificationText;
       sessionStorage.setItem("sscNotificationshown","true");
      } else { 
        this.sscNotification = false;
        this.modalSize = undefined;
        this.lastResponse = ''
        this.triggerModal = false;
        this.alertModel = false;
      }
    },
    isShowEIPLink(v){
      if(this.showEIP2LinkForLTC == 'true' && v==2 && this.dashboardData.currentCompanyCode==1){
        return true
      }
      if(this.showEIP2LinkForNonLTC == 'true' && v==2 && this.dashboardData.currentCompanyCode!=1){
        return true
      }
      if(this.showEIP4LinkForLTC == 'true' && v==4 && this.dashboardData.currentCompanyCode==1){
        return true
      }
      if(this.showEIP4LinkForNonLTC == 'true' && v==4 && this.dashboardData.currentCompanyCode!=1){
        return true
      }
    },
    showHalfLength(v){
      if(this.showEIP2LinkForLTC == 'true' && this.showEIP4LinkForLTC == 'true' && this.dashboardData.currentCompanyCode==1){
        return 'half-length'
      }
      if(this.showEIP2LinkForNonLTC == 'true' && this.showEIP4LinkForNonLTC == 'true' && this.dashboardData.currentCompanyCode!=1){
        return 'half-length'
      }

    },
    navigateToEIP(v) {      
      if(!window.document.documentMode && v == 2) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Kindly use Internet Explorer 11 browser only to go to EIP 2.0.";
        return;
      }
      if(window.document.documentMode && v == 4) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Kindly use Google Chrome browser only to go to EIP 4.0.";
        return;
      }
      var audit = sessionStorage.getItem("AuditNumber");
      var auditNumber = this.EncodeUsingAES(audit);
      var vendorCode = this.EncodeUsingAES(this.dashboardData.partnerNumber);
      var company = this.EncodeUsingAES(this.dashboardData.currentCompanyCode);
      var partnerType =
      this.dashboardData.currentCategoryCode == 2 ? "Supplier" : "Service Provider";
      var transcode = this.EncodeUsingAES("VEND_LOGIN");
      var partner = this.EncodeUsingAES(partnerType);

      var source = this.EncodeUsingAES("Partner");
      var rurl=''
      if(v == 2)
      {
      rurl =  `${process.env.VUE_APP_INVOICE_URL}?auditNumber=${auditNumber}&vendorCode=${vendorCode}&PP_TranCode=${transcode}&CompanyCode=${company}&PartnerType=${partner}`;
      } else if (v == 4){
      rurl = `${process.env.VUE_APP_EIPFOUR_REDIRECT_URL}/?Source=JlRHLQ88nR72g6Rw59IKOA==&RefId=${vendorCode}&AuditNo=${auditNumber}&Company=${company}&PartnerType=${partner}&URL=eiproot%2Fdashboard&ReturnURL=${window.location.href}`
      }
      window.location = rurl
    },
    resetBusinessTypeConformation () {      
        this.resetBusinessTypeSubmitConformation = true;
    },    
    closeConfirmationModal() {
      this.resetBusinessTypeSubmitConformation = false;
    },
    resetBusinessType() {
          this.loading = true;
      DashboardServices.resetBusinessType(
        this.dashboardData.currentCategoryCode,
        this.dashboardData.currentCompanyCode).then(resp => {
                this.loading = false;
      this.resetBusinessTypeSubmitConformation = false;
         if(resp.status=='FAILURE'){
                this.triggerModal = true;
                this.alertModel = true;
                this.lastResponse = resp.failureMessage;
         } else {
                this.triggerModal = true;
                this.successModel = true;
                this.lastResponse = resp.response;
           this.dontShowBussinessType = false;
         }
        })
        .catch(error => {
              console.log(err);
      this.resetBusinessTypeSubmitConformation = false;
              this.loading = false;
              this.triggerModal = true;
              this.alertModel = true;
              this.lastResponse = err.failureMessage;
        });
    },
    showAlertBusinessModal(event) {
      this.triggerModal = true;
      this.alertModel = true;
      if (event == null) {
        this.lastResponse = "This Business Type is Already Added";
      } else {
        this.lastResponse = event;
      }
    },
    updateTheSecondaryBussiness(event) {
      console.log(event);
      this.updateBussinessNavbar = true;
      this.getPartnerDetails();
    },
    updateTheBranchBussiness() {
      console.log(event);
      this.updateBussinessNavbar = true;
      this.getBranchPrimaryBussinessDetail();
    },
    getEbidAuctionDate(event) {
      this.getEbidAuction(event[0], event[1]);
    },
    bindCategoryValue(category, type) {
      var selectedBussiness = [];
      if (type == "onetime") {
        if (category && category.length == 1) {
          if (this.branchBussinessCategory) {
            this.branchBussinessCategory.forEach(element => {
              category.forEach(categories => {
                if (element.value == categories.value) {
                  selectedBussiness.push({
                    name: element.name,
                    value: element.value
                  });
                }
              });
            });
          }
          this.multiCategorySelectedValues = selectedBussiness;
          return selectedBussiness;
        }
      } else {
        if (this.branchBussinessCategory) {
          this.branchBussinessCategory.forEach(element => {
            console.log(element);
            category.forEach(data => {
              console.log(data);
              console.log(category);
              if (element.value == data.value) {
                selectedBussiness.push({
                  name: element.name,
                  value: element.value
                });
              }
            });
          });
        }
        console.log(selectedBussiness);
        return selectedBussiness;
      }
    },
    bindSubCategoryValue(category, type) {
      var selectedBussiness = [];
      if (type == "onetime") {
        if (category && category.length == 1) {
          if (category && category.length == 1) {
            if (this.branchBussinessSubCategory) {
              this.branchBussinessSubCategory.forEach(element => {
                category.forEach(subCategories => {
                  if (element.value == subCategories.value) {
                    selectedBussiness.push({
                      name: element.name,
                      value: element.value
                    });
                  }
                });
              });
            }
            this.multiSubCategorySelectedValues = selectedBussiness;
            return selectedBussiness;
          }
        }
      } else {
        if (this.branchBussinessSubCategory) {
          this.branchBussinessSubCategory.forEach(element => {
            category.forEach(subCategories => {
              if (element.value == subCategories.value) {
                selectedBussiness.push({
                  name: element.name,
                  value: element.value
                });
              }
            });
          });
        }
        return selectedBussiness;
      }
    },
    defaultSelection() {
      var beforDate = new Date();
      beforDate.setDate(beforDate.getDate() - 50);
      var afterDate = new Date();
      afterDate.setDate(afterDate.getDate() + 20);
      if (beforDate && afterDate) {
        this.selectedDateRange.push(beforDate, afterDate);
        var currentMonth = new Date();
        currentMonth.setMonth(currentMonth.getMonth() - 10);
        this.disableDateBefore = currentMonth;
        var diasbleAfter = new Date();
        diasbleAfter.setMonth(diasbleAfter.getMonth() + 5);
        this.disableDateAfter = diasbleAfter;
        this.getEbidAuction(beforDate, afterDate);
      }
    },

    getEBIDDetails() {
      DashboardServices.getEIPPartnerDetails().then(resp => {
        resp.response.partnerNumber.forEach(data => {
          this.partnerCodeValue.push({
            value: data.vendorCode,
            category: data.category
          });
        });
        this.defaultSelection();
        // this.getEbidAuction();
        // this.vendorCode = resp.response.vendorCode;
      });
    },

    getEbidAuction(fromDate, toDate) {
      this.showTableLoding = true;
      var data = {};
      data.uid = "1";
      data.type = "Public";
      var partner = [];
      this.partnerCodeValue.forEach(item => {
        partner.push(item.value);
      });
      data.partnerCode = partner;
      data.startDate = fromDate;
      data.endDate = toDate;
      data.companyCode = this.dashboardData.currentCompanyCode;
      
        DashboardServices.getEbid(data).then(resp => {
          this.ebidData = resp.response;
          this.ebidDataTable.items = resp.response.ebid;
          this.eAuctionTable.items = resp.response.eauction;
          this.showTableLoding = false;
        });
      clearInterval(this.ebidintr);
      this.ebidintr = setInterval(() => {
        DashboardServices.getEbid(data).then(resp => {
          this.ebidData = resp.response;
          this.ebidDataTable.items = resp.response.ebid;
          this.eAuctionTable.items = resp.response.eauction;
          this.showTableLoding = false;
        });      
      }, 60000)
      // this.tableLoading = false;
    },

    goToOnboardingPage(event) {
      if(this.defaultCompanyDetails.companyCode != this.dashboardData.currentCompanyCode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding by switching to your default company '" + 
        this.defaultCompanyDetails.company + "' in top right corner menu option.";
        return;        
      }
      if(window.document.documentMode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding using Google Chrome Browser";
        return;
      }
      if (this.dontAllowOnboarding == true) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please add your secondary business";
        return;
      }
      if (
        this.dashboardData.primaryBusiness.categories.length == 0 ||
        this.dashboardData.primaryBusiness.subCategories.length == 0
      ) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please add your business categories";
        return;
      }
      if (
        this.dashboardData.primaryBusiness.categoryCode ==
        this.dashboardData.currentCategoryCode
      ) {
      }
      if (this.businessType == false) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please add the Business Type";
        return;
      }

       if (this.currencyType == false || this.selectedCurrencyUnit == null) { //&& this.$root.isInternational
         this.triggerModal = true;
         this.alertModel = true;
         this.lastResponse = "Please submit the Primary Operating Currency type and units";
         return;
       }

      if (
        this.dashboardData.primaryBusiness.categoryCode ==
        this.dashboardData.currentCategoryCode
      ) {
      } else {
        if (this.dashboardData.primaryIncorporatedAs == null && !this.$root.isInternational) {
          this.triggerModal = true;
          this.alertModel = true;
          this.lastResponse =
            "Please complete your primary business organization detail to continue secondary business ";
          return;
        }
      }

      if (this.onBoardingCompletionStatus == "View") {
        // this.$router.push('/onboardingDetails')
        this.$router.push("/onboardingDetailPreview");
        return;
      } else {
        this.$router.push("/onboardingDetails");
      }
    },
    redirectionPage(bidDetail) {
      var partnerValue = "";
      // if (bidDetail.partnerTypeCategory) {
      //   this.partnerCodeValue.forEach(partner => {
      //     if (partner.category == bidDetail.partnerTypeCategory) {
      //        partnerValue = partner.value;
      //     }
      //    });
      // }
      //  if (partnerValue != "") {
      var partnerCode = this.EncodeUsingAES(this.dashboardData.partnerNumber);
      var companyCodeValue = this.EncodeUsingAES(
        this.dashboardData.currentCompanyCode
      );
      var audit = sessionStorage.getItem("AuditNumber");
      var auditNumber = this.EncodeUsingAES(audit);
      var source = this.EncodeUsingAES("Partner");
      var partner = this.EncodeUsingAES(bidDetail.partnerType);
      if (partnerCode && companyCodeValue && auditNumber) {
        window.location = this.redirectUrl(
          partnerCode,
          companyCodeValue,
          auditNumber,
          source,
          partner
        );
      }
      // }
    },
    redirectUrl(partnerCode, companyCode, AuditNumber, source, partner) {
      return `${process.env.VUE_APP_ESOURCING_REDIRECT_URL}/?RefId=${partnerCode}&Company=${companyCode}&AuditNo=${AuditNumber}&Source=${source}&PartnerType=${partner}&URL=eSourcingPartnersUI%2Fbiddersquote&ReturnURL=${window.location.href}`;
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    encrypt(text) {
      var AES = require("crypto-js/aes");
      var SHA256 = require("crypto-js/sha256");
      var CryptoJS = require("crypto-js");
      var encrypted = {};
      var cryptobject = {};
      cryptobject = CryptoJS.AES.encrypt(text, this.encryptsecret);
      encrypted = {
        key: cryptobject.key + "", // don't send this
        iv: cryptobject.iv + "", // don't send this
        salt: cryptobject.salt + "", // don't send this
        ciphertext: cryptobject.ciphertext + "", // don't send this
        str: cryptobject + "" // send or store this
      };
      // var bytes  =  CryptoJS.AES.decrypt(encrypted.str, this.encryptsecret).toString(CryptoJS.enc.Latin1)
      // var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      // console.log("ENCRYPT",encrypted)
      sessionStorage.removeItem("userToken");
      sessionStorage.setItem("userToken", encrypted.str);
      // console.log("DECRYPT",bytes)
    },

    onboardingStatus() {
      this.loading = true;
      DashboardServices.getPartnertype(
        this.dashboardData.currentCompanyCode
      ).then(resp => {
        if (resp.response) {
          var onboardResponseStatus = resp.response;
          onboardResponseStatus.forEach((item, index) => {
            if (
              item.partnerTypeCode == this.dashboardData.currentCategoryCode
            ) {
              if (item.status == null || item.status == "N") {
                this.onBoardingCompletionStatus = "OnProgress";
              }
              if (item.status == "C") {
                this.encrypt("View");
                this.onBoardingCompletionStatus = "View";
              }
              if (item.status == "S") {
                this.encrypt("Edit");
                this.onBoardingCompletionStatus = "Edit";
                this.recentStatusChangeRemarks = item.recentStatusChangeRemarks;
              }
              if (item.status == "A") {
                this.$router.push("/partnerdashboard");
                return;
              }
            }
            if (item.status == "A") {
              this.showParnterDashboarNavigation = true;
            }
          });
        }

        //             this.onBoardingCompletionStatus = resp.failureMessage
        //             if(resp.failureMessage == "No Status"){
        //                   this.loading = false;
        //               this.completeProfile = "E"
        //               console.log(this.completeProfile)
        //               if (this.businessType != false){
        //               this.encrypt('Edit')
        //               }
        //             }
        //             this.onBoardingCompletion = resp.response.status

        // // ONCE APPROVED NAVIGATE TO PARTNER DAHSBOARD

        //             if(this.onBoardingCompletion == "A"){
        //             this.$router.push('/partnerdashboard')
        //                         return;
        //             }
        //               if(this.onBoardingCompletion == "C"){
        //               this.encrypt('View')
        //             }else{
        //               this.encrypt('Edit')

        //             }
        //             this.editProfile = resp.response.onboardEvaluationStatus
      });
    },

    goToOnboardingPageModule(event) {
      this.$router.push("/onboardingDetails");
    },
    //  getServicesList(){
    //    DashboardServices.getServices().then(resp=>{
    //     console.log(resp);
    //    })
    //  },
    showalert() {
      this.alertModel = false;
      // this.$router.go(this.$router.currentRoute);
    },

    changeModalStatus() {
      this.alertModel = false;
      this.$router.go(this.$router.currentRoute);
    },    
    handleDeclarationModel(){
      this.triggerDeclarationModal = false;
    },
    handleModel() {
      this.triggerModal = false;
      this.boldText = false;
      this.needResendEmail = false;
      this.sscNotification = false;
      this.modalSize = undefined;
      if (this.successModel == true) {
        this.successModel = false;
        this.$router.go(this.$router.currentRoute);
      }
      this.alertModel = false;

      
      if(this.isMigratedUser != 'N' && this.showSscNotification) {
         this.showSSCNotification()
      }
    },

    businessTypeChange() {
      if(this.defaultCompanyDetails.companyCode != this.dashboardData.currentCompanyCode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding by switching to your default company '" + 
        this.defaultCompanyDetails.company + "' in top right corner menu option.";
        return;        
      }
      // this.businessType = false;
      this.showBussinessTypes = true;
      // this.show
    },
    cancelEditedBusiness() {
      this.showBussinessTypes = false;
    },
    getPartnerDetails() {
      this.loading = true;
      this.primaryBusinessesPopupItems = [];
      this.secondaryBusinessesPopupItems = [];
      DashboardServices.getPartnerDetails()
        .then(resp => {
          if (resp) {
            // if(resp.response.onboardStatus == "A"){
            //               this.dashboardData = resp.response;
            //    this.onboardingStatus();
            //       //  this.$router.push('/partnerdashboard')
            //       // return;
            // }
            this.loading = false;
            
            this.showBranch =
              resp.response.partnerCategory == "B" ? true : false;
              this.countrycode = resp.response.countryDetail.countryCode
            this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
            console.log(this.showBranch);
            this.partnerId = resp.response.partnerId;
            // Code added to save partner id to session storage
            sessionStorage.setItem("uniqueID", this.partnerId);
            this.dashboardData = resp.response;  
            
            this.dashboardData.secondaryBusiness = this.dashboardData.secondaryBusiness.filter(x=>x.categoryName != 'Customer')
           
            this.getEBIDDetails();
            // this.isMigratedUser = resp.response.isMigratedUser;   
            this.showEIP4LinkForLTC = resp.response.showEIP4LinkForLTC
            this.showEIP4LinkForNonLTC = resp.response.showEIP4LinkForNonLTC
            this.showEIP2LinkForLTC = resp.response.showEIP2LinkForLTC
            this.isDeleteAllowed = resp.response.isDeleteAllowed
            this.isTaxComponentAllowed = resp.response.isTaxComponentAllowed
            this.showEIP2LinkForNonLTC = resp.response.showEIP2LinkForNonLTC
            this.showSscNotification = resp.response.showSscNotification
            
        this.itrcutoffmonth = resp.response.itrCutoffMonth          
        this.idCardValue = resp.response.idCardValue  
             
        this.showSkipDeclaration = resp.response.showSkipDeclaration
            sessionStorage.setItem("isAttachmentsNotMandatory", this.dashboardData.makeAttachmentsNotMandatory);
            
            for (
              let i = 0;
              i < this.dashboardData.secondaryBusiness.length;
              i++
            ) {
              var secondaryData = {
                categories: [],
                subCategories: []
              };
              secondaryData.primaryBusiness = this.dashboardData.secondaryBusiness[
                i
              ].categoryCode;
              for (
                let j = 0;
                j < this.dashboardData.secondaryBusiness[i].categories.length;
                j++
              ) {
                secondaryData.categories.push({
                  name: this.dashboardData.secondaryBusiness[i].categories[j]
                    .categoryName,
                  value: this.dashboardData.secondaryBusiness[i].categories[j]
                    .categoryCode,
                  company: this.dashboardData.currentCompanyCode
                });
              }
              for (
                let k = 0;
                k <
                this.dashboardData.secondaryBusiness[i].subCategories.length;
                k++
              ) {
                secondaryData.subCategories.push({
                  name: this.dashboardData.secondaryBusiness[i].subCategories[k]
                    .categoryName,
                  value: this.dashboardData.secondaryBusiness[i].subCategories[
                    k
                  ].categoryCode,
                  company: this.dashboardData.currentCompanyCode
                });
              }
              console.log(secondaryData);
              this.secondaryBusinessesPopupItems.push(secondaryData);
            }

            if (this.dashboardData.primaryBusiness.categoryCode) {
              var primaryData = {
                categories: [],
                subCategories: [],
                partnerType: [],
                primaryCategoryApproval: []
              };
              primaryData.primaryBusiness = this.dashboardData.primaryBusiness.categoryCode;
              primaryData.primaryCategoryApproval.push({
                text: this.dashboardData.primaryBusiness
                  .categoryForApprovalDesc,
                value: this.dashboardData.primaryBusiness
                  .primaryCategoryForApproval
              });
              primaryData.partnerType.push({
                text: this.dashboardData.primaryBusiness.categoryName,
                value: this.dashboardData.primaryBusiness.categoryCode
              });
              for (
                let j = 0;
                j < this.dashboardData.primaryBusiness.categories.length;
                j++
              ) {
                primaryData.categories.push({
                  name: this.dashboardData.primaryBusiness.categories[j]
                    .categoryName,
                  value: this.dashboardData.primaryBusiness.categories[j]
                    .categoryCode,
                  company: this.dashboardData.currentCompanyCode
                });
              }
              for (
                let k = 0;
                k < this.dashboardData.primaryBusiness.subCategories.length;
                k++
              ) {
                primaryData.subCategories.push({
                  name: this.dashboardData.primaryBusiness.subCategories[k]
                    .categoryName,
                  value: this.dashboardData.primaryBusiness.subCategories[k]
                    .categoryCode,
                  company: this.dashboardData.currentCompanyCode
                });
              }
             //If no currency code then refer native currency from country detail
             if (resp.response.currencyType.code == null) {//uncomment
               this.selectedCurrency = resp.response.countryDetail.nativeCurrencyCode;
             } else {
               this.selectedCurrency = resp.response.currencyType.code;
             }
             this.getPartnerCurrencyType(this.selectedCurrency);
             this.selectedCurrencyUnit = resp.response.currencyUnitType.code;
             /*if(!this.$root.isInternational) {
               this.selectedCurrencyUnit = 1; // lakhs default for India

               var currencyData = {}
               currencyData.partnerId = this.dashboardData.partnerId;
              currencyData.categoryCode = this.dashboardData.currentCategoryCode;
              currencyData.companyCode = this.dashboardData.companyCode;
              currencyData.currencyTypeCode = this.selectedCurrency;
              currencyData.currencyUnitTypeCode = this.selectedCurrencyUnit;
              this.loading = true;
              DashboardServices.sendCurrencyTypes(currencyData)
                .then(res => {
                  if (res.response == "Added Currency Types to Partner Successfully") {
                    this.loading = false;
                  }
                })
                .catch();

             }*/
            }

            console.log(primaryData);
            this.primaryBusinessesPopupItems.push(primaryData);

            this.getPartnerProgress();
            this.getBusinessTypeStatus();
            this.onboardingStatus();
            if (this.showBranch == true) {
              this.getBranchPrimaryBussinessDetail();
            }
            this.getCurrencies(); //uncomment
            this.getCurrencyStatus(); //uncomment

            // this.getBusinessType();
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    pushToSelectedService(event) {
      this.serviceSelected = [];
      console.log(event);
      this.selectedRadio = event;
      this.serviceSelected.push(this.selectedRadio);
    },

    copyPrimaryData() {
      const postData = {
            partnerID: this.partnerId,
            companyCode: this.dashboardData.currentCompanyCode
            };
        DashboardServices.copyData(postData).then(resp => {
          this.copyDataArray = resp.response;
          this.showSuccessAlert();
        })
        .catch(error => {
          console.error('Error fetching data from Primary Business:', error);
        });
      },
      showSuccessAlert() {
        alert('Action is successful');        
      },
      
    getBusinessTypeStatus() {
      this.loading = true;
      DashboardServices.getBusinessTypeStatus(
        this.dashboardData.currentCategoryCode,
        this.dashboardData.currentCompanyCode
      ).then(resp => {
        //  alert('business types', resp.response)
        console.log(resp);
        if (resp) {
          if (resp.response.length > 0) {
            this.loading = false;
            this.selectedBusinessTypes = resp.response;
            this.serviceSelected = this.selectedBusinessTypes;

            if (this.dashboardData.currentCategoryCode == 2) {
              this.selectedBusinessTypes.forEach((data, index) => {
                // this.serviceSelected[index] = data.id
                // console.log(this.serviceSelected[index])
                this.pushToSelectedService(data.id);
                console.log(data.id);
              });
            } else {
              console.log(this.selectedBusinessTypes);
              this.selectedBusinessTypes.forEach((data, index) => {
                this.serviceSelected[index] = data.id;

                //       this.serviceOptions.push({
                //   text: option.longDesc,
                //   value: option.id
                // });
                // this.pushToSelectedService(data.id);
                console.log(data.id);
              });
              console.log(this.serviceOptions);
            }

            this.businessType = true;
            this.showBussinessTypes = false;
            this.getBusinessType();
          } else {
            this.showBussinessTypes = true;
            this.getBusinessType();
          }
          if (
            this.dashboardData.primaryBusiness.categoryCode !=
            this.dashboardData.currentCategoryCode
          ) {
            if (this.dashboardData.secondaryBusiness.length == 0) {
              this.dontShowBussinessType = true;
              this.businessType = true;
              this.dontAllowOnboarding = true;
            } else if (
              this.dashboardData.secondaryBusiness[0].categories.length == 0
            ) {
              this.dontAllowOnboarding = true;
            }
          }
        }
      });
    },
    getMultiCategorySelectedDropdown(event) {
      console.log(event);
      this.multiCategorySelectedValues = event;
      
      var categoryArray = [];
      for (let i = 0; i < event.length; i++) {
        categoryArray.push(event[i].value);
      }
      DashboardServices.getSubCategoryList(categoryArray).then(resp => {
        let res = resp.response;
        this.branchBussinessSubCategory = [];
        for (let i = 0; i < res.length; i++) {
          this.branchBussinessSubCategory.push({
            name: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
        if(this.branchBussinessSubCategory.length == 1) { //to prevent bug in multi select widget if only one dropdown list is present
          for (let i = 0; i < res.length; i++) {
          this.branchBussinessSubCategory.push({
            name: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
        }
        console.log(this.branchBussinessSubCategory);
      });
    },
    getMultiSubCategorySelectedDropdown(event) {
      console.log(event);
      this.multiSubCategorySelectedValues = event;
    },
    branchBussinessCategorySelect(type) {
      this.loading = true;
      var selectedCategory = [];
      var selectedSubCategory = [];
      this.multiCategorySelectedValues.forEach(category => {
        selectedCategory.push(category.value);
      });
      this.multiSubCategorySelectedValues.forEach(subcategory => {
        selectedSubCategory.push(subcategory.value);
      });
      if (type == "onetime") {
        let data = {};
        data.branchCategory = selectedCategory;
        data.branchSubCategory = selectedSubCategory;
        data.companyCode = this.dashboardData.currentCompanyCode;
        console.log(data);
        if (selectedCategory.length > 0 && selectedSubCategory.length > 0) {
          DashboardServices.saveBranchBussiness(data)
            .then(resp => {
              if (resp.response) {
                this.loading = false;
                this.triggerModal = true;
                this.successModel = true;
                this.lastResponse = resp.response;
                this.addBusinessModal = false;
              } else {
              }
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.triggerModal = true;
              this.alertModel = true;
              this.lastResponse = err.failureMessage;
            });
        }
      } else {
        let editData = {};
        editData.partnerId = this.partnerId;
        editData.businessType = "P";
        editData.partnerBusinessCode = this.dashboardData.currentCategoryCode;
        editData.partnerBusinessTypeCodes = [];
        editData.categories = selectedCategory;
        editData.subCategories = selectedSubCategory;
        editData.companyCode = this.dashboardData.currentCompanyCode;
        if (selectedCategory.length > 0 && selectedSubCategory.length > 0) {
          DashboardServices.editSecondaryBusiness(editData)
            .then(resp => {
              if (resp.response) {
                this.loading = false;
                this.triggerModal = true;
                this.successModel = true;
                this.lastResponse = "Branch category updated succesfully";
                this.addBusinessModal = false;
              } else {
              }
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.triggerModal = true;
              this.alertModel = true;
              this.lastResponse = err.failureMessage;
            });
        }
      }
    },
    branchBussinessTypeSubmit() {
      this.branchInfo = 1;
    },
    bindBranchCategory() {
      console.log(event);
    },
    bindBranchSubCategory() {
      console.log(event);
    },
    getPartnerProgress() {
      this.loading = true;
      DashboardServices.getProgressDetails(
        this.dashboardData.currentCategoryCode,
        this.dashboardData.currentCompanyCode,
        this.$root.isInternational
      ).then(resp => {
        if (resp.response != null) {
          this.loading = false;
          this.listOfModules = [];
          this.percentageOfModules = [];
          this.doughnutChartData = [];
          this.progressDetails = resp.response;
          this.moduleData = this.progressDetails.modules;

          if (this.progressDetails.answeredQuestions != 0) {
            this.showBussinessModel = true;
          }

          this.moduleData.forEach((modules, index) => {
            let data = {
              data: [
                parseInt(
                  (modules.answeredQuestions / modules.totalQuestions) * 100
                ),
                100 -
                  parseInt(
                    (modules.answeredQuestions / modules.totalQuestions) * 100
                  )
              ],
              backgroundColor: [this.getColorFromIndex(index), "#0000ff10"],
              labels: [
                modules.moduleName + "(Completed)",
                modules.moduleName + "(Yet to be Filled)"
              ]
            };
            this.doughnutChartData.push(data);
            this.listOfModules.push(modules.moduleName);
            this.percentageOfModules.push(
              parseInt(
                (modules.answeredQuestions / modules.totalQuestions) * 100
              )
            );
          });
          console.log(this.listOfModules, this.percentageOfModules);

          if (this.progressDetails.answeredQuestions == null) {
            console.log(
              this.progressDetails.answeredQuestions,
              this.progressDetails.totalQuestions
            );
            this.profileCompletionPercentage = parseInt(
              (0 / this.progressDetails.totalQuestions) * 100
            );
            console.log("1", this.profileCompletionPercentage);
          } else {
            console.log(this.progressDetails.answeredQuestions, "null?");
            this.profileCompletionPercentage = parseInt(
              (this.progressDetails.answeredQuestions /
                this.progressDetails.totalQuestions) *
                100
            );
            if (
              this.dashboardData.currentCategoryCode == 2 &&
              this.profileCompletionPercentage > 0
            ) {
              this.dontShowBussinessType = true;
            }
            console.log("2", this.profileCompletionPercentage);
          }
        } else {
          this.loading = false;
        }
      });
    },
    getColorFromIndex(index) {
      let arrayOfColors = [
        "#FE8B6D",
        "#70AE4D",
        "#FFDB6B",
        "#FF8CD0",
        "#D0D88F",
        "#C2D4E9",
        "#FBE895",
        "#AAD38E",
        "#91ABD6",
        "#F47039"
      ];
      // let arrayOfColors = ["#262245","#251E58","#241A6A","#24177C","#241492","#230FA4","#230DB6","#2309CA","#2105DB","#2102F0"];
      arrayOfColors.reverse();
      return arrayOfColors[index];
    },
    getRandomColor() {
      // let arrayOfColors = ["#0156b1", "#042d59", "#030b99", "#49acfc", "#000000"]
      let arrayOfColors = [
        "#FE8B6D",
        "#70AE4D",
        "#FFFB6B",
        "#FF8CD0",
        "#D0D88F",
        "#C2D4E9",
        "#FBE895",
        "#AAD38E",
        "#91ABD6",
        "#F47039"
      ];
      return arrayOfColors[Math.floor(Math.random() * arrayOfColors.length)];
      // var letters = '0123456789ABCDEF';
      // var color = '#';
      // for (var i = 0; i < 6; i++) {
      //   color += letters[Math.floor(Math.random() * 16)];
      // }
      // return color;
    },
    getBusinessType() {
      var self = this
      DashboardServices.getMigrationStatus(
        this.dashboardData.currentCompanyCode,
        this.dashboardData.currentCategoryCode,
        this.partnerId
      ).then(resp => {
        if (resp) {
          self.isMigratedUser = resp.response
            if(self.isMigratedUser != 'N' && this.dashboardData.timeTillEIPMenuAllowed !== null) {
                var timeTillEIPMenuAllowed = (new Date(this.dashboardData.timeTillEIPMenuAllowed)).getTime()
                var now = (new Date()).getTime()
                this.timeTillEIPMenuAllowed = (new Date(this.dashboardData.timeTillEIPMenuAllowed))
                var x = this.timeTillEIPMenuAllowed.toString()
                x = x.substr(0, x.lastIndexOf(' ('))
                x = x.split(' ')
                x[4] = x[4].split(':').slice(0,-1).join(':')
                this.timeTillEIPMenuAllowed = x.join(' ')
                console.log(timeTillEIPMenuAllowed - now)
                if (timeTillEIPMenuAllowed > now) {
                  var noOfDaysRemaining = Math.round((timeTillEIPMenuAllowed-now)/(1000*60*60*24))
                  if (noOfDaysRemaining == 0) {
                    noOfDaysRemaining = 'less than a day'
                  } else if (noOfDaysRemaining == 1) {
                    noOfDaysRemaining = '1 day'
                  } else {
                    noOfDaysRemaining = noOfDaysRemaining + ' days'
                  } 
                  noOfDaysRemaining.bold()
                  this.isAllowedEIPWithoutOnboarding = true
                  this.boldText = false;
                  this.needResendEmail = false;     
                  this.modalSize = 'xl';
                  if(sessionStorage.getItem("isEIPmenuNotified") != "Y") {
                    sessionStorage.setItem("isEIPmenuNotified", "Y");
                    this.triggerModal = true;
                    this.alertModel = true;
                    this.lastResponse = "Dear Business Partner, Thanks for logging-in L&T’s Partner Portal. Please help us to know you more and thereby strengthen the business ties. Please complete the onboarding process in order to ensure uninterrupted login to EIP. As you are our valued partner, you have been given a temporary option of redirection to EIP from this page. This option will be disabled on the <span style='color:red;font-weight:bold;'> "+ this.timeTillEIPMenuAllowed + "</span>. You have  <span style='color:red;font-weight:bold;'>" +noOfDaysRemaining+"</span> to complete the onboarding process, after which you will not be able to login to EIP without completing the onboarding. Thanks for your understanding and cooperation";
                  }
                } else if (self.isMigratedUser != 'N' && this.dashboardData.isGraceEIPLink == 'Y' &&
                this.dashboardData.timeTillEIPMenuAllowed !== null && this.dashboardData.eiplinkExtraGraceDate != null){
                 
                 var newGraceDate=this.dashboardData.eiplinkExtraGraceDate.replace('00:00:00','23:59:59.000')
                 var timeTillEIPMenuAllowed= (new Date(newGraceDate)).getTime()
                var now = (new Date()).getTime()
                this.timeTillEIPMenuAllowed = (new Date(newGraceDate))
                var x = this.timeTillEIPMenuAllowed.toString()
                x = x.substr(0, x.lastIndexOf(' ('))
                x = x.split(' ')
                x[4] = x[4].split(':').slice(0,-1).join(':')
                this.timeTillEIPMenuAllowed = x.join(' ')
                console.log(timeTillEIPMenuAllowed - now)
                if (timeTillEIPMenuAllowed > now) {
                  var noOfDaysRemaining = Math.round((timeTillEIPMenuAllowed-now)/(1000*60*60*24))
                  if (noOfDaysRemaining == 0) {
                    noOfDaysRemaining = 'less than a day'
                  } else if (noOfDaysRemaining == 1) {
                    noOfDaysRemaining = '1 day'
                  } else {
                    noOfDaysRemaining = noOfDaysRemaining + ' days'
                  } 
                  noOfDaysRemaining.bold()
                  this.isAllowedEIPWithoutOnboarding = true
                  this.boldText = false;
                  this.needResendEmail = false;     
                  this.modalSize = 'xl';
                  if(sessionStorage.getItem("isEIPmenuNotified") != "Y") {
                    sessionStorage.setItem("isEIPmenuNotified", "Y");
                    this.triggerModal = true;
                    this.alertModel = true;
                    this.lastResponse = "Dear Business Partner, Thanks for logging-in L&T’s Partner Portal. Please help us to know you more and thereby strengthen the business ties. Please complete the onboarding process in order to ensure uninterrupted login to EIP. As you are our valued partner, you have been given a temporary option of redirection to EIP from this page. This option will be disabled on the <span style='color:red;font-weight:bold;'> "+ this.timeTillEIPMenuAllowed + "</span>. You have  <span style='color:red;font-weight:bold;'>" +noOfDaysRemaining+"</span> to complete the onboarding process, after which you will not be able to login to EIP without completing the onboarding. Thanks for your understanding and cooperation";
                  }
                }
                }
            }
        }
        
            if(this.isMigratedUser != 'N' && !this.isAllowedEIPWithoutOnboarding &&
               this.dashboardData.timeTillEIPMenuAllowed !== null && this.showSscNotification){                
                   this.showSSCNotification()
               }
            if(this.isMigratedUser != 'N'){                  
        if(this.dashboardData.countryDetail.countryCode == 100) {          
          partnerService.getDeclarationStatus().then(resp => {
          if(resp.response.declarationTag != 'Y'){
           this.triggerDeclarationModal=true //show ssc declaration
          }
          })
        }
            }
      });
      DashboardServices.getBusinessTypes(
        this.dashboardData.currentCompanyCode,
        this.dashboardData.currentCategoryCode
      ).then(resp => {
        console.log(resp);
        if (resp) {
          this.serviceOptions = [];
          // this.serviceSelected.forEach((data, i) => {
          resp.response.forEach((option, index) => {
            this.serviceOptions.push({
              text: option.longDesc,
              value: option.id
            });

            // if (this.showBranch) {
            //   if (data == option.id) {
            //     this.serviceOptions.push({
            //       text: option.longDesc,
            //       value: option.id,
            //       disabled: true
            //     });
            //   } else {
            //     this.serviceOptions.push({
            //       text: option.longDesc,
            //       value: option.id
            //     });
            //   }
            // } else {
            //   this.serviceOptions.push({
            //     text: option.longDesc,
            //     value: option.id
            //   });
            // }
          });
          // });
          // this.serviceSelected.forEach((data, i) => {
          //   this.serviceOptions.forEach((option, index) => {
          //     if (data == option.value) {
          //       this.serviceOptions.push({
          //         disabled: true
          //       });
          //     }
          //   });
          // });

          console.log(this.serviceOptions);
        }
      });
    },
    addNewBusiness() {
      if(this.defaultCompanyDetails.companyCode != this.dashboardData.currentCompanyCode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding by switching to your default company '" + 
        this.defaultCompanyDetails.company + "' in top right corner menu option.";
        return;        
      }
      if (this.businessType == false) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please add the Business Type";
      } else {
        this.addSecondaryBussiness = true;
        this.addBusinessModal = true;
        // this.$refs.secondaryBusinessModal.checkItemEmpty();
      }
    },
    addBranchBussinessDetail() {
      this.addBranchBussiness = true;
      this.addBusinessModal = true;
    },
    editPrimaryBusiness() {
      if(this.defaultCompanyDetails.companyCode != this.dashboardData.currentCompanyCode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding by switching to your default company '" + 
        this.defaultCompanyDetails.company + "' in top right corner menu option.";
        return;        
      }
      this.addPrimaryBussiness = true;
      this.addBusinessModal = true;
    },
    closeSecondaryModal() {
      if (this.dashboardData.primaryBusiness.categories != null) {
        if (this.updateBussinessNavbar) {
          this.$router.go(this.$router.currentRoute);
        }
        this.addSecondaryBussiness = false;
        this.addPrimaryBussiness = false;
        this.addBusinessModal = false;
      } else {
        // this.addBusinessModal = true;
      }
    },
    sendBusinessType() {
      if(this.defaultCompanyDetails.companyCode != this.dashboardData.currentCompanyCode) {
        this.triggerModal = true;
        this.alertModel = true;
        this.lastResponse = "Please complete onboarding by switching to your default company '" + 
        this.defaultCompanyDetails.company + "' in top right corner menu option.";
        return;        
      }
      let data = {};
      data.partnerId = this.dashboardData.partnerId;
      data.categoryCode = this.dashboardData.currentCategoryCode;
      data.companyCode = this.dashboardData.currentCompanyCode;
      data.businessTypes = this.serviceSelected;
      if((this.serviceSelected.indexOf(7) > -1 || this.serviceSelected.indexOf(4) > -1)
       && this.serviceSelected.length > 1) {
        window.alert("Business type 'Professional Services / Consultants' and 'Regular Labour Sub-Contractor' cannot be chosen along with other business types. Select only one of them or uncheck it continue.")
        return false;
     }
      this.loading = true;
      DashboardServices.sendBusinessType(data).then(resp => {
        if (resp.response.indexOf("Added Business to Partner Successfully")>-1) {
          this.loading = false;
          this.triggerModal = true;
          this.successModel = true;
          this.lastResponse = resp.response;
        }
      });
    },
    getBranchPrimaryBussinessDetail() {
      this.branchBusinessesPopupItems = [];
      this.multiCategorySelectedValues = [];
      this.multiSubCategorySelectedValues = []; 
      var branchData = {
        categories: [],
        subCategories: [],
        partnerType: [],
        primaryCategoryApproval: []
      };
      DashboardServices.getBranchPrimaryBussiness(
        this.dashboardData.currentCompanyCode,
        this.dashboardData.currentCategoryCode
      ).then(resp => {
        this.parentBussinessData = resp.response;
        // branchData.primaryBusiness = this.dashboardData.primaryBusiness.categoryCode;
        // branchData.primaryCategoryApproval.push({
        //   text: this.dashboardData.primaryBusiness.categoryForApprovalDesc,
        //   value: this.dashboardData.primaryBusiness.primaryCategoryForApproval
        // });
        branchData.partnerType.push({
          text: this.parentBussinessData.categoryName,
          value: this.parentBussinessData.categoryCode
        });
        for (let j = 0; j < this.parentBussinessData.categories.length; j++) {
          branchData.categories.push({
            name: this.parentBussinessData.categories[j].categoryName,
            value: this.parentBussinessData.categories[j].categoryCode
          });

          this.branchBussinessCategory.push({
            name: this.parentBussinessData.categories[j].categoryName,
            value: this.parentBussinessData.categories[j].categoryCode
          });
        }
        
        for (let j = 0; j < this.parentBussinessData.allcategories.length; j++) {
          this.branchBussinessAllCategory.push({
            name: this.parentBussinessData.allcategories[j].categoryName,
            value: this.parentBussinessData.allcategories[j].categoryCode
          });
        }
        for (
          let k = 0;
          k < this.parentBussinessData.subCategories.length;
          k++
        ) {
          branchData.subCategories.push({
            name: this.parentBussinessData.subCategories[k].categoryName,
            value: this.parentBussinessData.subCategories[k].categoryCode
          });
          this.branchBussinessSubCategory.push({
            name: this.parentBussinessData.subCategories[k].categoryName,
            value: this.parentBussinessData.subCategories[k].categoryCode
          });
        }
        this.branchBusinessesPopupItems.push(branchData);
        if (
          this.dashboardData.primaryBusiness.categories == null ||
          (this.dashboardData.primaryBusiness.categories &&
            this.dashboardData.primaryBusiness.categories.length == 0)
        ) {
          this.addBusinessModal = true;
          this.addBranchBussiness = true;
        } else {
          this.dashboardData.primaryBusiness.categories.forEach(data => {
            this.multiCategorySelectedValues.push({
              name: data.categoryName,
              value: data.categoryCode
            });
          });
          this.dashboardData.primaryBusiness.subCategories.forEach(data => {
            this.multiSubCategorySelectedValues.push({
              name: data.categoryName,
              value: data.categoryCode
            });
          });
        }
      });
    },
    getGroupCharts(event) {
      this.groupChartData = [];
      this.selectedModule = null;
      this.selectedModule = event;
      DashboardServices.getGroupChartData(
        this.selectedModule,
        this.dashboardData.currentCategoryCode,
        this.dashboardData.currentCompanyCode
      ).then(resp => {
        console.log(resp);
        this.groupContent = resp.response.moduleInfo.description;
        let data = { labels: [], backgroundColor: [], data: [] };
        resp.response.groups.forEach((group, index) => {
          // data.status.push(status)
          data.labels.push(group.groupName);
          data.backgroundColor.push(this.getColorFromIndex(index));
          data.data.push(
            (group.answeredQuestions / group.totalQuestions) * 100
          );
        });
        console.log(data);
        this.groupChartData.push(data);
      });
      // getGroupCharts
    },
    getCurrencies() {
      this.currencyOptions = [];
      DashboardServices.getAllCurrencies()
        .then(res => {
          res.response.forEach(element => {
            this.currencyOptions.push({
              text: element.longDesc + " - " + element.shortDesc,
              value: element.currencyCode
            });
          });
        })
        .catch();
    },
    getPartnerCurrencyType(event) {
      this.selectedCurrency = event;
      this.selectedCurrencyUnit = "";
      this.currencyUnitsOptions = [];
      DashboardServices.getCurrencyUnitsByCurrencyCode(event)
        .then(res => {
          if(res.response.length > 0){
          res.response.forEach(element => {
            this.currencyUnitsOptions.push({
              text: element.longDesc,
              value: element.currencyUnitCode
            });
          });
          }
        })
        .catch();
    },
    getPartnerCurrencyUnitType(event) {
      this.selectedCurrencyUnit = event;
    },
    sendCurrencyType() {
      let data = {};
      data.partnerId = this.dashboardData.partnerId;
      data.categoryCode = this.dashboardData.currentCategoryCode;
      data.companyCode = this.dashboardData.companyCode;
      data.currencyTypeCode = this.selectedCurrency;
      data.currencyUnitTypeCode = this.selectedCurrencyUnit;
      this.loading = true;
      DashboardServices.sendCurrencyTypes(data)
        .then(res => {
          if (res.response == "Added Currency Types to Partner Successfully") {
            this.loading = false;
            this.triggerModal = true;
            this.successModel = true;
            this.lastResponse = "Currency Types Added Successfully";
          }
        })
        .catch();
    },
    currencyTypeChange() {
      this.showCurrencyTypes = true;
    },
    cancelEditCurrencyType() {
      this.showCurrencyTypes = false;
    },
    getCurrencyStatus() {
      if (this.selectedCurrency != null && this.selectedCurrencyUnit != null) {
        this.currencyType = true;
      } else {
        this.showCurrencyTypes = true;
      }
      if (
        this.dashboardData.primaryBusiness.categoryCode !=
        this.dashboardData.currentCategoryCode
      ) {
        //this.currencyType = false;
        this.showSelectCurrencyType = false;
      }
    }
  }
};
</script>
<style scoped>
.dashboard-heading {
  font-size: 36px;
  font-weight: 600;
  line-height: 1.53;
  letter-spacing: normal;
  text-align: left;
  color: #002d72;
}
.Ebid-card {
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.bussinesscard {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  width: auto !important;
  height: 100% !important;
}
.card-width {
  padding: 40px;
  width: fit-content;
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.profile-percentage {
  font-size: 21px;
  font-weight: 600;
  line-height: 1.19;
  color: #002d72;
}
.profile-completion-text {
  font-size: 14px;
  /* line-height: 1.33; */
  text-align: center;
  color: #002d72;
}
.complete-profile-btn {
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: 0.8px;
  text-align: right;
  color: #003a78;
  width: fit-content;
  outline: none;
}
.complete-profile-btn:disabled {
  cursor: not-allowed !important;
}
.gradient-button {
  font-size: 14px;
  color: #2c3e50;
  background: linear-gradient(to bottom, #f6f6f6, #d8d8d8);
  border: none;
  padding: 5px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin: auto;
  margin-top: 0px;
}

.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 5px;
  z-index: 999;
}
.v-progress-circular {
  margin: 0 auto;
}
.progress-color {
  background-color: #e2e2e2;
}
.progress-text {
  font-size: 16px;
  font-weight: normal;
  line-height: 1.25;
  text-align: left;
  color: #646464;
}
.progress-text > p {
  font-size: 16px;
  font-weight: normal;
  line-height: 1.25;
  text-align: left;
  color: #646464;
}
.bid-top-headings {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  text-align: left;
  color: #636567;
}
.card-top-headings {
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #484848;
}
.setup-btn {
  color: #003a78 !important;
  width: fit-content;
  font-size: 16px !important;
}
.right-arrow {
  width: 25px;
  height: 11px;
  vertical-align: inherit;
}
.right-arrow-complete-profile {
  width: 40px;
  height: 15px;
  vertical-align: inherit;
}
.progress-card-heading {
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: left;
  color: #636567;
  margin-bottom: 0;
}
.hr-style {
  background-color: #f8f8f8;
  width: 100%;
  margin: 0 auto;
}
.card-shadows {
  border-radius: 4px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
}
.left-heads {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  text-align: left;
  color: #484848;
}
.right-values {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  text-align: left;
  color: #2f2f2f;
}
.primary-card-text-style {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  color: #2b2b2b;
}
.expansion-styles {
  margin: 0 !important;
  width: 100% !important;
  height: auto;
  border: none;
}
.view-add-btn {
  margin: auto 0;
  margin-right: 0 !important;
  cursor: pointer;
  width: fit-content;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: 0.8px;
  text-align: right;
  color: #003a78;
}
.checkbox-style {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #272727;
  width: fit-content;
}
.secondary-account-modal {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.05;
  letter-spacing: normal;
  text-align: left;
  color: #636567;
}
.row-loader {
  width: fit-content !important;
}
.secondary-close {
  position: absolute;
  right: 20px;
  top: 22px;
}
.card-sizing {
  width: 100% !important;
  height: auto !important;
}
.fixed-height {
  max-height: 350px;
  overflow: auto;
}
.full-height {
  height: 100% !important;
}
.module-description {
  font-size: 16px;
  color: #2b2b2b;
}
.right-align-edit-business {
  margin: 0 !important;
  width: fit-content;
  float: right;
}
.edit-business-type-col {
  margin: auto !important;
  width: fit-content;
}
.inner-details {
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: var(--black);
}
.inner-card-headings {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: var(--black);
}
@media (min-width: 320px) {
  .dashboard-header-name {
    margin-top: 45px;
  }
}
.text-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px !important;
  font-weight: bold !important;
}

.excl{
  background: #ffffff;
    border-radius: 10px;
    padding: 0px 6px;
    margin-right: 5px;
    color: #ec0000;
    font-weight: bold;
    box-shadow: 1px 1px 0px #7b7b7b;
}
.half-length{width:49% !important;}
</style>
<style>
.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    box-shadow: 2px 2px 5px yellow inset;
  }
}

.disabled-check{
  cursor: none;
    pointer-events: none;
    opacity: 0.5;
}

.btn-warnn:hover{
  background: #ff3900;
  border-color: #ff3900;
  color:#fff;
}
</style>
